/**
 * Shared SSR-safe predicate for App Migration top sticky banner visibility.
 * Used by MobileHeaderProvider, AppMigrationTopBanner, and height hook so
 * first paint matches hydration (no CLS).
 *
 * Top banner is home-only (not PLP / PDP). Dismissal is Redux session state.
 * Experiment eligibility (app-migration-a) comes from SSR abExperiments.
 */

import { WEB_APP_TYPE } from 'shared/constants';

export interface IShouldShowTopBannerParams {
  isTopBannerDismissed: boolean;
  webAppType: string;
  appMigrationEnabled: boolean;
  isTopBannerVisible: boolean;
  /** True when eligible for app-migration experiment with variant A */
  isAppMigrationVariantA: boolean;
  pathname: string;
  search?: string;
  isWebView: boolean;
}

const isHomePath = (pathname: string): boolean =>
  pathname === '/' || pathname === '/international';

/**
 * Returns true when the top banner should render on SSR and first client paint.
 * Home page only; requires remote flags + app-migration-a; dismiss is Redux session state.
 */
export const shouldShowAppMigrationTopBanner = ({
  isTopBannerDismissed,
  webAppType,
  appMigrationEnabled,
  isTopBannerVisible,
  isAppMigrationVariantA,
  pathname,
  search = '',
  isWebView,
}: IShouldShowTopBannerParams): boolean => {
  if (!appMigrationEnabled) return false;
  if (!isTopBannerVisible) return false;
  if (!isAppMigrationVariantA) return false;
  if (webAppType !== WEB_APP_TYPE.MWEB) return false;
  if (isWebView) return false;
  if (!isHomePath(pathname)) return false;
  if (search.includes('showsearch')) return false;
  if (isTopBannerDismissed) return false;

  return true;
};
